import { getCountryCodeByPhoneNumber } from '@shared/utils/country.helper';
import { useState } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import BasicPhoneInput from './basic-phone-input';
import { Label } from '../text-area/app-text-area';
import clsx from 'clsx';

type AppPhoneInputProps<T extends FieldValues> = {
  required?: boolean;
  label?: string;
  name: Path<T>;
  placeholder?: string;
  control: Control<T>;
  suffixLabel?: React.JSX.Element;
  bordered?: boolean;
  size?: 'small' | 'large';
};

export function AppPhoneInput<T extends FieldValues>(props: AppPhoneInputProps<T>) {
  const { required, label, name, placeholder, suffixLabel, control, bordered = true, size } = props;
  const [countryCode, setCountryCode] = useState('');

  return (
    <div className="flex flex-col gap-1.5 w-full">
      <Label suffixLabel={suffixLabel} required={required}>
        {label}
      </Label>

      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          return (
            <div className="w-full flex flex-col gap-1.5">
              <BasicPhoneInput
                value={value ?? ''}
                onChange={(value, newCountryCode) => {
                  onChange(value);
                  if (newCountryCode) setCountryCode(newCountryCode);
                  else setCountryCode(getCountryCodeByPhoneNumber(value) || countryCode);
                }}
                countryCode={countryCode || getCountryCodeByPhoneNumber(value) || 'US'}
                placeholder={placeholder}
                rootClassName={clsx(!bordered && 'mx-auto', error ? 'border-red-500!' : '')}
                bordered={bordered}
                size={size}
              />
              {error && (
                <p className={clsx('text-sm font-normal text-red-500', size === 'small' && 'text-center')}>
                  {error.message}
                </p>
              )}
            </div>
          );
        }}
      />
    </div>
  );
}
